export default __webpack_public_path__ + "static/media/Visualización de Datos - Freecodecamp.01a32405.png";